import { render, staticRenderFns } from "./ClinicChYndromeDic.vue?vue&type=template&id=887c9836"
import script from "./ClinicChYndromeDic.vue?vue&type=script&lang=js"
export * from "./ClinicChYndromeDic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('887c9836')) {
      api.createRecord('887c9836', component.options)
    } else {
      api.reload('887c9836', component.options)
    }
    module.hot.accept("./ClinicChYndromeDic.vue?vue&type=template&id=887c9836", function () {
      api.rerender('887c9836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicChYndromeDic.vue"
export default component.exports